import React from 'react';
import { Card } from '../ui/card';
import { FileText, Settings } from 'lucide-react';

export const ContextMenuDemo: React.FC = () => {
  const demoFileContent = "Hello World!\nThis is a sample text file.\nYou can right-click on files in File Explorer to open them in different applications.";

  const handleCreateDemoFile = () => {
    // Create a demo file and trigger the hex editor
    window.dispatchEvent(new CustomEvent('openFileInApp', {
      detail: {
        appId: 'hex-editor',
        filePath: 'C:\\Demo\\sample.txt',
        content: demoFileContent
      }
    }));
  };

  return (
    <div className="p-6 space-y-4">
      <h2 className="text-xl font-semibold mb-4">Context Menu & Hex Editor Demo</h2>
      
      <Card className="p-4">
        <h3 className="font-medium mb-2">How to use:</h3>
        <ol className="list-decimal list-inside space-y-2 text-sm">
          <li>Navigate to any file in File Explorer</li>
          <li>Right-click on the file to open the context menu</li>
          <li>Select "Open with" → "Hex Editor" to view the file in hex format</li>
          <li>Or click the button below to try the hex editor with sample data</li>
        </ol>
      </Card>

      <div className="space-y-2">
        <button
          onClick={handleCreateDemoFile}
          className="flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded hover:bg-primary/90"
        >
          <Settings className="w-4 h-4" />
          Open Sample File in Hex Editor
        </button>
      </div>

      <Card className="p-4 bg-muted/50">
        <h4 className="font-medium mb-2">Hex Editor Features:</h4>
        <ul className="list-disc list-inside space-y-1 text-sm">
          <li>View file contents in hexadecimal and ASCII format</li>
          <li>Edit bytes by double-clicking or using the edit dialog</li>
          <li>Search for text or hex patterns</li>
          <li>Copy, cut, and paste operations</li>
          <li>Undo/redo functionality</li>
          <li>Save changes back to the virtual file system</li>
        </ul>
      </Card>
    </div>
  );
};